var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessagesFocused(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_934_12006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.86877 2.63175V7.23717H3.40145L3.01328 7.62534L2.63169 8.00693V2.63175H9.86877ZM10.5267 1.31592H1.97377C1.61192 1.31592 1.31586 1.61198 1.31586 1.97383V11.1847L3.94752 8.553H10.5267C10.8885 8.553 11.1846 8.25694 11.1846 7.89508V1.97383C11.1846 1.61198 10.8885 1.31592 10.5267 1.31592ZM13.8163 3.94758H12.5004V9.86883H3.94752V11.1847C3.94752 11.5465 4.24359 11.8426 4.60544 11.8426H11.8425L14.4742 14.4743V4.6055C14.4742 4.24365 14.1781 3.94758 13.8163 3.94758Z",
    fill: "#12BFE0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_934_12006"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.79,
    height: 15.79,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesFocused);
export default __webpack_public_path__ + "static/media/messagesFocused.cc9cdfbc2f7408e7705c522106414973.svg";
export { ForwardRef as ReactComponent };